import { render, staticRenderFns } from "./manageClassPopup.vue?vue&type=template&id=1e6472e9&scoped=true&"
import script from "./manageClassPopup.vue?vue&type=script&lang=js&"
export * from "./manageClassPopup.vue?vue&type=script&lang=js&"
import style0 from "./manageClassPopup.vue?vue&type=style&index=0&id=1e6472e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6472e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e6472e9')) {
      api.createRecord('1e6472e9', component.options)
    } else {
      api.reload('1e6472e9', component.options)
    }
    module.hot.accept("./manageClassPopup.vue?vue&type=template&id=1e6472e9&scoped=true&", function () {
      api.rerender('1e6472e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mass/scriptLibrary/manageClassPopup.vue"
export default component.exports